import { Link, usePage } from "@inertiajs/react";
import Flash from "@/components/Flash";

export default function AuthLayout({ children }) {
  const { routes } = usePage().props;

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4">
      <Flash />
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <Link href={routes.home} className="text-2xl font-bold tracking-tight text-foreground">
            GameKnight
          </Link>
        </div>
        {children}
      </div>
    </div>
  );
}
